<div class="modal-dialog"
     id="new-request">
  <div class="modal-content p-0">
    <div class="modal-header">
      <button (click)="closeDialog()"
              class="close"
              data-dismiss="modal"
              type="button">
        <div class="dialog-close"></div>
      </button>
      <span>{{ 'FactorDetails' | translate }}</span>
    </div>
  </div>
</div>
<mat-dialog-content class="mat-typography">
  <div class="modal-body"
       style="position: relative;">
    <div class="factor-detail-container">
      <div class="factor-summary">
        <div class="summary-header">
          <div class="factor-id">
            <span class="id-label">{{ 'FactorID' | translate }}</span>
            <span class="id-value">#{{ factor?.FactorId }}</span>
          </div>
          <div class="factor-status">
                                <span [style.background-color]="getFactorStatusColor(factor?.Status)"
                                      class="status-badge">
                    {{ getFactorStatusText(factor?.Status) | translate }}
                  </span>
          </div>
        </div>
      </div>
      <div class="info-section">
        <div class="info-columns">
          <div class="customer-column">
            <div class="column-title">
              <mat-icon>person</mat-icon>
              <span>{{ 'CustomerInformation' | translate }}</span>
            </div>
            <div class="customer-info">
              <div class="info-item">
                <div class="info-icon">
                  <mat-icon>person</mat-icon>
                </div>
                <div class="info-content">
                  <span class="info-value">{{ getUserDisplayName(factor?.User) }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="summary-column">
            <div class="column-title">
              <mat-icon>receipt</mat-icon>
              <span>{{ 'OrderSummary' | translate }}</span>
            </div>
            <div class="summary-info">
              <div class="info-item">
                <div class="info-icon">
                  <mat-icon>shopping_cart</mat-icon>
                </div>
                <div class="info-content">
                  <span class="info-label">{{ 'OrderCount' | translate }}:</span>
                  <span class="info-value">{{ getOrderCount() }}</span>
                </div>
              </div>
              <div class="info-item">
                <div class="info-icon">
                  <mat-icon>inventory</mat-icon>
                </div>
                <div class="info-content">
                  <span class="info-label">{{ 'TotalItems' | translate }}</span>
                  <span class="info-value">{{ getTotalItems() }}</span>
                </div>
              </div>
              <div class="info-item">
                <div class="info-icon">
                  <mat-icon>payment</mat-icon>
                </div>
                <div class="info-content">
                  <span class="info-label">{{ 'PaymentStatus' | translate }}:</span>
                  <span [style.color]="getPaymentStatusColor()"
                        class="info-value">{{ getPaymentStatus() | translate }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      @if (factor?.FactorOrders?.length > 0) {
        <div class="orders-section">
          <div class="section-header">
            <mat-icon>restaurant_menu</mat-icon>
            <h6>{{ 'Orders' | translate }} ({{ factor.FactorOrders?.length || 0 }})</h6>
          </div>
          <div class="order-items">
            @for (factorOrder of factor?.FactorOrders; track factorOrder; let i = $index) {
              <div class="order-item">
                <div class="product-card">
                  <div class="product-header">
                    <div class="product-icon">
                      <mat-icon>restaurant</mat-icon>
                    </div>
                    <div class="product-info">
                      <div class="product-name">
                        {{ factorOrder?.Order?.ServicePrice?.Service?.Title }}
                        <span class="quantity-badge">x{{ factorOrder?.Order?.Count }}</span>
                      </div>
                    </div>
                    <div class="product-price">
                      {{ formatCurrency(factorOrder?.Order?.ServicePrice?.Price * factorOrder?.Order?.Count) }}
                    </div>
                  </div>
                  <div class="order-status-info">
                                          <span
                                            [style.background-color]="getOrderStatusColor(factorOrder?.Order?.Status)"
                                            class="order-status">
                      {{ getOrderStatusText(factorOrder?.Order?.Status) | translate }}
                    </span>
                  </div>
                </div>
              </div>
            }
          </div>
          <!-- مجموع سفارشات -->
          <div class="order-total">
            <div class="total-label">
              <mat-icon>payments</mat-icon>
              <span>{{ 'Total' | translate }}</span>
            </div>
            <div class="total-amount">
              {{ formatCurrency(factor?.PayablePrice) }}
            </div>
          </div>
        </div>
      }

      <div class="financial-section">
        <div class="section-header">
          <mat-icon>account_balance_wallet</mat-icon>
          <h6>{{ 'FinancialDetails' | translate }}</h6>
        </div>
        <div class="financial-details">
          <div class="financial-row">
            <div class="financial-item">
              <span class="label">{{ 'TotalSum' | translate }}:</span>
              <span class="value">{{ formatCurrency(factor?.Price) }}</span>
            </div>
            <div class="financial-item">
              <span class="label">{{ 'Tax' | translate }}:</span>
              <span class="value">{{ formatCurrency(factor?.TaxPrice) }}</span>
            </div>
            <div class="financial-item">
              <span class="label">{{ 'ShippingCost' | translate }}:</span>
              <span class="value">{{ formatCurrency(factor?.DeliveryPrice) }}</span>
            </div>
            <div class="financial-item">
              <span class="label">{{ 'ExtraAmount' | translate }}:</span>
              <span class="value">{{ formatCurrency(factor?.ExtraPrice) }}</span>
            </div>
          </div>
        </div>
      </div>

      @if (factor?.Metadata) {
        <div class="payment-section">
          <div class="section-header">
            <mat-icon>credit_card</mat-icon>
            <h6>{{ 'PaymentInformation' | translate }}</h6>
          </div>
          <div class="payment-details">
            <div class="payment-row">
              @if (factor?.PaymentMethod?.Type === 'PSP') {
                <div class="payment-item">
                  <span class="label">{{ 'PaymentMethod' | translate }}:</span>
                  <span class="value">{{ 'PSP' | translate }}</span>
                </div>
                <div class="payment-item">
                  @if (factor?.PaymentMethod?.Metadata?.PSP === 'SAMAN') {
                    <img [height]="20"
                         [src]="'/icons/logo-saman-bank.svg'"
                         [width]="20"/>
                  } @else if (factor?.PaymentMethod?.Metadata?.PSP === 'ZARINPAL') {
                    <img [height]="20"
                         [src]="'/icons/zarinpal.svg'"
                         [width]="20"/>
                  }
                  <span class="value">{{ factor?.PaymentMethod?.Title }}</span>
                </div>
                <div class="payment-item">
                  <span class="label">{{ 'TrackingCode' | translate }}:</span>
                  <span class="value">{{ factor?.TraceNo }}</span>
                </div>
              } @else if (factor?.PaymentMethod?.Type === 'CARD_TO_CARD') {
                <div class="payment-item">
                  <span class="label">{{ 'PaymentMethod' | translate }}:</span>
                  <span class="value">{{ 'CardToCard' | translate }}</span>
                </div>
                <div class="payment-item">
                  <span class="label">{{ 'Cardholder' | translate }}:</span>
                  <span class="value">{{ factor?.Metadata?.Card?.CardholderName }}</span>
                </div>
                <div class="payment-item">
                  <span class="label">{{ 'CardNumber' | translate }}:</span>
                  <span class="value">{{ factor?.Metadata?.Card?.CardNumber }}</span>
                </div>
                <div class="payment-item">
                  <span class="label">{{ 'Bank' | translate }}:</span>
                  <span class="value">{{ factor?.Metadata?.Card?.BankName }}</span>
                </div>
                <div class="payment-item">
                  <span class="label">{{ 'TrackingCode' | translate }}:</span>
                  <span class="value">{{ factor?.Metadata?.TraceCode }}</span>
                </div>
                <div class="payment-item">
                  <span class="label">{{ 'CardToCardReceipt' | translate }}:</span>
                  <a [href]="formatImage('',factor?.Metadata?.CardToCardReceipt)"
                     style="width: 20px;height: 20px"
                     target="_blank">
                    <img [height]="20"
                         [src]="formatImage('',factor?.Metadata?.CardToCardReceipt)"
                         [width]="20"/>
                  </a>
                </div>
              } @else if (factor?.PaymentMethod?.Type === 'POS') {
                <div class="payment-item">
                  <span class="label">{{ 'PaymentMethod' | translate }}:</span>
                  <span class="value">{{ 'Pos' | translate }}</span>
                </div>
                <div class="payment-item">
                  <span class="label">{{ 'PaymentMethod' | translate }}:</span>
                  <span class="value">{{ 'Pos' | translate }}</span>
                </div>
              } @else {
                <div class="payment-item">
                  <span class="label">{{ 'PaymentMethod' | translate }}:</span>
                  <span class="value">{{ factor?.PaymentMethod?.Title | translate }}</span>
                </div>
              }
            </div>
          </div>
        </div>
      }

      <div class="timeline-section">
        <div class="section-header">
          <mat-icon>schedule</mat-icon>
          <h6>{{ 'TimeInformation' | translate }}</h6>
        </div>
        <div class="timeline-details">
          <div class="timeline-row">
            <div class="timeline-item">
              <span class="label">{{ 'CreationDate' | translate }}:</span>
              <span class="value">{{ formatDate(factor?.CreateDate) }}</span>
            </div>
            <div class="timeline-item">
              <span class="label">{{ 'LastModified' | translate }}:</span>
              <span class="value">{{ formatDate(factor?.ModifyDate) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
<div class="dialog-footer">
  <mat-dialog-actions align="end"
                      class="py-0">
    <div class="col-12 d-flex align-items-center justify-content-end footer"
         style="gap: 16px">
      <app-frontend-button (click)="closeDialog()"
                           [Image]="true"
                           [class]="'card-yellow'"
                           [disabled]="false"
                           [src]="'icons/close-square.svg'"
                           [title]="'Cancel'">
      </app-frontend-button>
    </div>
  </mat-dialog-actions>
</div>
